import React from 'react';
import {
  InputContainer,
  InputGeneral,
  Label,
  LabelIcon,
  InputMask,
} from './styles';
import {
  ErrorMessage,
  FormController,
} from '../../../assets/global/globalStyles';
import useFormType from '../../../hooks/useFormType';

/**
 * @param props
 * @param {String} props.name
 * @param {String} props.label
 */
export default function Input({
  name,
  label,
  children,
  grid,
  gridRow,
  mask,
  ...rest
}) {
  const { fieldName, defaultValue, error, ref, location } = useFormType(name);

  return (
    <FormController grid={grid} gridRow={gridRow}>
      <InputContainer>
        {mask ? (
          <InputMask
            mask={mask}
            location={location.pathname}
            defaultValue={defaultValue}
            autoCapitalize="off"
            autoComplete="off"
            autoCorrect="off"
            id={fieldName}
            error={error}
            ref={ref}
            {...rest}
          />
        ) : (
          <InputGeneral
            location={location.pathname}
            defaultValue={defaultValue}
            autoCapitalize="off"
            autoComplete="off"
            autoCorrect="off"
            id={fieldName}
            error={error}
            ref={ref}
            {...rest}
          />
        )}
        <Label htmlFor={fieldName} error={error} className="placeholder">
          {label}
        </Label>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        {children && <LabelIcon>{children}</LabelIcon>}
      </InputContainer>
    </FormController>
  );
}
